document.addEventListener("DOMContentLoaded", function() {
    const thickeningAgents = {
        "Cornstarch": 0.01,  // 1% of liquid weight
        "Flour": 0.02,  // 2% of liquid weight
        "Arrowroot": 0.008,  // 0.8% of liquid weight
        "Tapioca Starch": 0.01,  // 1% of liquid weight
        "Xanthan Gum": 0.002,  // 0.2% of liquid weight
        "Guar Gum": 0.003  // 0.3% of liquid weight
    };

    function calculateThickener() {
        let volumeInput = document.getElementById("volume").value;
        let unit = document.getElementById("unit").value;
        let thickener = document.getElementById("thickener").value;

        if (!volumeInput || volumeInput <= 0) {
            alert("Please enter a valid batch size.");
            return;
        }

        let volume = unit === "oz" ? volumeInput * 29.5735 : volumeInput; // Convert ounces to ml if needed
        let ratio = thickeningAgents[thickener];
        let grams = (volume * ratio);
        let ounces = grams * 0.035274; // Convert grams to ounces

        document.getElementById("result").innerHTML = `
            <h3>Recommended Thickener Amount:</h3>
            <p><strong>${thickener}:</strong> ${grams.toFixed(2)} grams (${ounces.toFixed(2)} oz)</p>
        `;
    }

    document.getElementById("sauce-soup-thickening-calculator").innerHTML = `
        <div style="padding: 20px; border: 1px solid #ddd; border-radius: 8px; max-width: 400px; margin: auto; background-color: #f9f9f9;">
            <h2 style="text-align: center;">Sauce & Soup Thickening Calculator</h2>
            <label>Batch Size:</label>
            <input type="number" id="volume" style="width: 100%; padding: 5px; margin-bottom: 10px;">
            <select id="unit" style="width: 100%; padding: 5px; margin-bottom: 10px;">
                <option value="ml">Milliliters (ml)</option>
                <option value="oz">Ounces (oz)</option>
            </select>
            
            <label>Choose Thickening Agent:</label>
            <select id="thickener" style="width: 100%; padding: 5px; margin-bottom: 10px;">
                <option value="Cornstarch">Cornstarch</option>
                <option value="Flour">Flour</option>
                <option value="Arrowroot">Arrowroot</option>
                <option value="Tapioca Starch">Tapioca Starch</option>
                <option value="Xanthan Gum">Xanthan Gum</option>
                <option value="Guar Gum">Guar Gum</option>
            </select>

            <button id="calculate-btn" style="width: 100%; padding: 10px; background: #FF7E00; color: white; border: none; border-radius: 5px; cursor: pointer;">
                Calculate
            </button>

            <div id="result" style="text-align: center; font-weight: bold; margin-top: 15px;"></div>
        </div>
    `;

    document.getElementById("calculate-btn").addEventListener("click", calculateThickener);
});
